var _excluded = ["toCacheUrl"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var SESSION_KEY = 'tableParams';
var getTableParamsfromSession = function getTableParamsfromSession(key) {
  var sessionParams = sessionStorage.getItem(key);
  return sessionParams ? JSON.parse(sessionParams) : {};
};
export var setTableParamsToSession = function setTableParamsToSession(key, params) {
  var currentParams = getTableParamsfromSession(key);
  sessionStorage.setItem(key, JSON.stringify(_objectSpread(_objectSpread({}, currentParams), params)));
};
var removeTableParamsFromSession = function removeTableParamsFromSession(key) {
  sessionStorage.removeItem(key);
};
var isIncludePath = function isIncludePath(pathname, sessionParamsObj) {
  return Object.keys(sessionParamsObj).some(function (key) {
    return pathname.includes(key);
  });
};
var iseEqualPath = function iseEqualPath(pathname, sessionParamsObj) {
  return Object.keys(sessionParamsObj).some(function (key) {
    return pathname === key;
  });
};
export var getUrlRelationValues = function getUrlRelationValues(pathname, sessionParamsObj) {
  if (pathname && sessionParamsObj && Object.keys(sessionParamsObj).length > 0 &&
  //   iseEqualPath(pathname, sessionParamsObj)
  //  ||
  !isIncludePath(pathname, sessionParamsObj)) {
    removeTableParamsFromSession(SESSION_KEY);
  }
  return pathname ? sessionParamsObj[pathname] : {};
};
var hasCacheUrl = function hasCacheUrl(pathname, sessionParamsObj) {
  if (!sessionParamsObj) {
    return false;
  }
  return Object.keys(sessionParamsObj).some(function (key) {
    var _ref = sessionParamsObj[key] || {},
      toCacheUrl = _ref.toCacheUrl;
    if (Array.isArray(toCacheUrl) && toCacheUrl.length > 0) {
      return toCacheUrl.includes(pathname);
    }
    return false;
  });
};
export var getInitialValues = function getInitialValues(_ref2) {
  var pathname = _ref2.pathname,
    cacheKey = _ref2.cacheKey,
    toCacheUrl = _ref2.toCacheUrl;
  var sessionParamsObj = getTableParamsfromSession(SESSION_KEY);
  //页面有配置缓存的
  // if (cacheKey && toCacheUrl && pathname) {
  // 命中缓存 key
  if (cacheKey && sessionParamsObj && sessionParamsObj[cacheKey]) {
    var _ref3 = sessionParamsObj[cacheKey] || {},
      _toCacheUrl = _ref3.toCacheUrl,
      rest = _objectWithoutProperties(_ref3, _excluded);
    return _objectSpread({}, rest);
  }
  // 跟 toCacheUrl 有关系的路由略过
  if (pathname && hasCacheUrl(pathname, sessionParamsObj)) {
    return {};
  }
  // 其他情况没关系的清除缓存
  //   removeTableParamsFromSession(SESSION_KEY);
  //   return {};
  // }
  // 如果跳转没有上下级关系 或者路径相等，清除session
  return pathname ? getUrlRelationValues(pathname, sessionParamsObj) : {};
};
export function getList(result) {
  var code = result.code,
    data = result.data;
  if (code === 200) {
    return data.rows || data.list || [];
  }
  return [];
}
var TABLE_REQUEST_SESSION_KEY = 'table_request';
export var getTableRequestFromSession = function getTableRequestFromSession() {
  return JSON.parse(sessionStorage.getItem(TABLE_REQUEST_SESSION_KEY) || '{}');
};
export var filterObJkey = function filterObJkey(obj, filterCacheSearchKey) {
  if (filterCacheSearchKey && filterCacheSearchKey.length > 0) {
    var newObj = {};
    var filterCacheSearchKeyMap = filterCacheSearchKey.reduce(function (pre, cur) {
      return pre[cur] = true, pre;
    }, {});
    Object.keys(obj).forEach(function (key) {
      if (!filterCacheSearchKeyMap[key]) {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  }
  return obj;
};
export var setTableRequestToSession = function setTableRequestToSession(key, value) {
  var obj = getTableRequestFromSession();
  sessionStorage.setItem(TABLE_REQUEST_SESSION_KEY, JSON.stringify(_objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, value))));
};